var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$hasLoading(_vm.type))?_c('div',{staticClass:"ez-loader",style:(_vm.style)},[_c('Spinner',{attrs:{"color":_vm.spinnerColor,"size":_vm.spinnerSize}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }